import React from "react";
import { THEME } from "../../theme";

export const AppField = ({
  id,
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  autoComplete,
  inputMode,
  suffix,
  className = "",
}) => (
  <div className={className}>
    <label
      htmlFor={id}
      className="mb-2 block text-[11px] font-bold uppercase tracking-[0.18em]"
      style={{ color: THEME.text.tertiary }}
    >
      {label}
    </label>
    <div
      className="app-field flex h-12 items-center rounded-lg border bg-black/25 transition-all"
      style={{ borderColor: "rgba(255,255,255,0.08)" }}
    >
      <input
        id={id}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        inputMode={inputMode}
        className="h-full w-full bg-transparent px-4 text-[15px] text-white placeholder:text-white/35 focus:outline-none"
      />
      {suffix}
    </div>
  </div>
);

export const AppButton = ({
  children,
  type = "button",
  disabled,
  onClick,
  variant = "primary",
  className = "",
}) => {
  const base =
    "flex h-12 w-full items-center justify-center rounded-lg text-[14px] font-extrabold tracking-tight text-white";
  const variantClass =
    variant === "primary" ? "app-btn-primary" : "app-btn-ghost";

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={`${base} ${variantClass} ${className}`}
    >
      {children}
    </button>
  );
};

export const AppAlert = ({ children, variant = "error" }) => {
  const isError = variant === "error";
  return (
    <div
      className="rounded-lg border px-4 py-3 text-[13px] font-medium leading-relaxed"
      style={{
        backgroundColor: isError ? "rgba(239,83,80,0.08)" : "rgba(46,204,113,0.08)",
        borderColor: isError ? "rgba(239,83,80,0.35)" : "rgba(46,204,113,0.35)",
        color: isError ? THEME.error : THEME.success,
      }}
    >
      {children}
    </div>
  );
};
